import React, { Component } from 'react';

export class SelectBox extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      y: 0,
      x: 0,
      width: 0,
      height: 0,
      isSelecting: false,
    };
    this.selectbox = null;
  }

  // TODO: pass internal ref via ForwardRef pattern rather than this construction
  // eslint-disable-next-line react/no-unused-class-component-methods
  getRef = () => this.selectbox; // used via ref of SelectBox

  getSelectboxRef = (ref) => {
    this.selectbox = ref;
  };

  render() {
    const { fixedPosition, className, delta } = this.props;
    const {
      isSelecting, width, y, x, height,
    } = this.state;

    if (!isSelecting) {
      this.selectbox = null;
    }

    const scale = delta || 1;
    const boxStyle = {
      left: x,
      top: y,
      width,
      height,
      zIndex: 9000,
      position: fixedPosition ? 'fixed' : 'absolute',
      cursor: 'default',
    };

    const wrapperStyle = scale !== 1 ? { transform: `scale(${1 / scale})`, transformOrigin: '0 0' } : {};

    return (
      <div style={wrapperStyle}>
        {isSelecting && (
          <div ref={this.getSelectboxRef} style={boxStyle} className={className} />
        )}
      </div>
    );
  }
}

SelectBox.defaultProps = {
  className: 'selectable-selectbox',
};
